import type { Permission, Role } from "@/types";

import { BaseApi } from "./base.api";

export interface RolePayload {
  name: string;
  description: string | null;
  /** Ruxsat KODLARI. Id emas: kod barqaror va API da ham ko'rinadi. */
  permissions: string[];
}

/**
 * Rollar va ruxsatlar (ADR 0009).
 *
 * Ruxsat ro'yxati faqat o'qiladi — uning manbasi backend kodi. Bu yerda
 * `createPermission` yo'q va bo'lmaydi.
 */
class AccessApi extends BaseApi {
  private readonly baseUrl = "/access";

  permissions() {
    return this.request<Permission[]>(`${this.baseUrl}/permissions`);
  }

  roles() {
    return this.request<Role[]>(`${this.baseUrl}/roles`);
  }

  getRole(id: string) {
    return this.request<Role>(`${this.baseUrl}/roles/${id}`);
  }

  createRole(payload: RolePayload & { code: string }) {
    return this.request<Role>(`${this.baseUrl}/roles`, { method: "POST", body: payload });
  }

  /** Kod o'zgartirilmaydi — u boshqa joyda havola sifatida ishlatiladi. */
  updateRole(id: string, payload: RolePayload) {
    return this.request<Role>(`${this.baseUrl}/roles/${id}`, { method: "PUT", body: payload });
  }

  deleteRole(id: string) {
    return this.request<void>(`${this.baseUrl}/roles/${id}`, { method: "DELETE" });
  }

  /**
   * Foydalanuvchining rollarini butun ro'yxat bilan almashtiradi.
   *
   * Bittalab qo'shish/olib tashlash emas: bu admin panelda bitta forma,
   * va ikkita alohida so'rov "qo'shildi, lekin olib tashlanmadi" degan
   * yarim holatni yaratardi.
   */
  setUserRoles(userId: string, roleIds: string[]) {
    return this.request<Role[]>(`${this.baseUrl}/users/${userId}/roles`, {
      method: "PUT",
      body: { roleIds },
    });
  }
}

export const accessApi = new AccessApi();
